import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export const translateY = byMedia(value => `transform: translateY(${getPx(value)});`);